import { HotBuyOrderItem } from "./types";
import * as React from "react";

export const renderHotBuyOrderItems = (items: HotBuyOrderItem[]) => {
 return <div>
     {
       items.map((item: HotBuyOrderItem) => {
         return (
           <div>
             <strong>Sell offer ID: {item.SellOfferID}</strong><br/>
             Property ID: {item.PropertyID}<br/>
             Name: {item.PropertyName}<br/>
             Amount: {item.TokenAmount}<br/>
             Token price: {item.TokenPriceTaker} USD<br/>
             Buyer price: {item.TotalPriceTaker} USD<br/>
             Seller price: {item.TotalPriceMaker} USD<br/>
             Nova commission: {item.TotalPriceFee} USD / {item.TokenPriceFeePercent}%<br/><br/>
           </div>
         )
       })
     }
 </div>
}
